export class TreeToDictionaryConverter {
  private readonly LIVR_ERROR_PROP = '_error';

  public toDictionary(tree: object | null): KeyValuePair[] {
    if (tree == null) return [];

    var result: KeyValuePair[] = [];
    this.processTree(tree, null, result);
    return result;
  }

  private processTree(tree: object, path: string | null, result: KeyValuePair[]): void {
    if (tree === null) return;

    for (var key in tree) {
      if (Object.prototype.hasOwnProperty.call(tree, key)) {
        var val = (tree as any)[key];
        var subPath = this.createSubPath(path, key);

        if (typeof val === 'string') {
          if (!subPath.endsWith(this.LIVR_ERROR_PROP)) {
            result.push({ value: val, key: subPath });
          }
        } else {
          if (val && Object.prototype.hasOwnProperty.call(val, this.LIVR_ERROR_PROP)) {
            result.push({ value: val[this.LIVR_ERROR_PROP], key: subPath });
          }
          this.processTree(val, subPath, result);
        }
      }
    }
  }

  private createSubPath(path: string | null, key: string): string {
    if (path === null) return key;

    return isNaN(Number(key)) ? path + '.' + key : path + '[' + key + ']';
  }
}

export class KeyValuePair {
  key: string;
  value: string;
}
